import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios'

import config from '../config'
import { UploadedFile } from '../utils/types'

axios.defaults.baseURL = `${config.API.REST.api.endpoint}/`

export const uploadFile = async (file: File): Promise<UploadedFile> => {
    const formData = new FormData()
    formData.append('file', file)

    const session = await fetchAuthSession()
    const jwt = session.tokens?.idToken?.toString()

    const res = await axios.post('/v1/files', formData, {
        headers: {
            Authorization: jwt,
            'Content-Type': 'multipart/form-data'
        }
    })

    if (res.status === 200) {
        return res.data as UploadedFile
    } else {
        throw new Error('Failed to upload file.')
    }
}
